export const creator_S13ITPIT = {
  theme: {
    is_telegram_white_theme: true,
  }
};